<template>
	<div class="user-center-container">
		<div class="benefit-feature-breadcrumb">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ name: 'MyBenefits' }">我的权益</el-breadcrumb-item>
				<el-breadcrumb-item>报告导出</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="user-center-header filter-container">
			<div class="filter-tabs">
				<div
					v-for="(tab, index) in exportTags"
					:key="index"
					:class="['tab-item', { active: searchForm.exportType === tab.value }]"
					@click="handleTabChange(tab.value)"
				>
					{{ tab.label }}
				</div>
			</div>

			<div class="filter-options">
				<div class="date-filter">
					<div
						v-for="(date, index) in dateOptions"
						:key="index"
						:class="['date-item', { active: currentDate === date.value }]"
						@click="handleDateChange(date.value)"
					>
						{{ date.label }}
					</div>

					<el-date-picker
						v-if="currentDate === 'custom'"
						v-model="customData"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="handleChangeCustomDate"
					></el-date-picker>

					<el-input
						v-model="searchForm.exportFileName"
						placeholder="请输入名称"
						class="search-input"
						@keyup.enter.native="initExportList"
					>
						<i slot="suffix" class="el-icon-search el-input__icon" @click="initExportList"></i>
					</el-input>
				</div>
			</div>
		</div>
		<div class="user-center-content">
			<data-table
				:table-data="exportGroups"
				:column="exportColumns"
				:page-options="pageOptions"
				:border="true"
				:index="true"
				:loading="loading"
				@page-change="handlePaginationChange"
			>
				<template slot="slot_name" slot-scope="data">
					<span>[{{ data.scope.row.exportTypeName }}]</span>
					<a href="javascript:;" class="download-link" @click="handleDownLoadRenewlReport(data.scope.row)">
						{{ data.scope.row.exportFileName }}
					</a>
				</template>
				<template slot="slot_time" slot-scope="data">
					{{ data.scope.row.createTime | formatDate }}
				</template>
			</data-table>
		</div>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { exportRecordPager, exportFileRecordRenewlDonwload } from '@/api/user/export'

	export default {
		name: 'UserExport',
		components: { DataTable },
		props: {},
		data() {
			return {
				searchForm: {
					exportType: '', // 文件类型
					exportFileName: '', // 文件名
					startTime: '',
					endTime: ''
				},
				// 时间筛选选项
				exportTags: [
					{ label: '全部类型', value: '' },
					{ label: '企业', value: '1' },
					{ label: '人员', value: '2' },
					{ label: '项目', value: '3' },
					{ label: '资质诊断报告', value: '4' }
				],
				// 时间筛选选项
				dateOptions: [
					{ label: '全部时间', value: 'allTime' },
					{ label: '今日', value: 'today' },
					{ label: '近7天', value: 'week' },
					{ label: '近30天', value: 'month' },
					{ label: '自定义', value: 'custom' }
				],
				currentDate: 'allTime',
				customData: '',

				exportColumns: [
					{ label: '名称', prop: 'name', align: 'center', slot: 'slot_name' },
					{ label: '时间', prop: 'createTime', align: 'center', width: '400' }
				],
				exportGroups: [],
				// 加载状态
				loading: false,
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				}
			}
		},
		computed: {},
		watch: {},
		created() {
			this.initExportList()
		},
		mounted() {},
		methods: {
			// TODO: 初始化导出记录
			initExportList() {
				this.loading = true
				const params = {
					exportType: this.searchForm.exportType,
					exportFileName: this.searchForm.exportFileName,
					startTime: this.searchForm.startTime,
					endTime: this.searchForm.endTime,
					page: this.pageOptions.page,
					size: this.pageOptions.limit
				}
				exportRecordPager(params)
					.then(res => {
						this.exportGroups = res.data.records
						this.pageOptions.total = res.data.total
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},
			// TODO: 根据tab筛选消息
			handleTabChange(tab) {
				this.searchForm.exportType = tab
				this.initExportList()
			},
			// 切换时间查询
			handleDateChange(date) {
				this.currentDate = date
				const now = new Date()
				const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const weekAgo = new Date(today)
				const monthAgo = new Date(today)
				// 修正为本地时间格式
				const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
					today.getDate()
				).padStart(2, '0')}`

				switch (date) {
					case 'allTime':
						this.searchForm.startTime = ''
						this.searchForm.endTime = ''
						break
					case 'today':
						this.searchForm.startTime = todayStr
						this.searchForm.endTime = todayStr
						break
					case 'week':
						weekAgo.setDate(weekAgo.getDate() - 6) // 包含今天共7天
						this.searchForm.startTime = weekAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'month':
						monthAgo.setMonth(monthAgo.getMonth() - 1)
						monthAgo.setDate(monthAgo.getDate() + 1) // 包含今天共30天
						this.searchForm.startTime = monthAgo.toISOString().split('T')[0]
						this.searchForm.endTime = todayStr
						break
					case 'custom':
						// 自定义时间段由el-date-picker处理
						break
				}
				if (date !== 'custom') {
					this.initExportList()
				}
			},
			// 自定义时间查询
			handleChangeCustomDate(value) {
				if (value) {
					this.searchForm.startTime = value[0]
					this.searchForm.endTime = value[1]
				}
				this.initExportList()
			},
			handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.initExportList()
			},

			// 报告导出记录中已导出的文件重新再次导出
			handleDownLoadRenewlReport(row) {
				window.open(exportFileRecordRenewlDonwload({ businessId: row.businessId }), '_blank')
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	.qualificationQuery-search {
		.searchForm {
			.el-form-item {
				width: 500px;
			}
		}
	}
	.date-filter {
		width: 100%;
		position: relative;
		.date-item {
			& + .date-item {
				margin-left: 0px !important;
			}
		}
		::v-deep {
			.el-range-editor.el-input__inner {
				height: 35px;
				border-radius: 0px;
			}
			.el-range-separator {
				line-height: 26px;
			}
		}
	}
	.search-input {
		float: right;
		width: 300px;
		height: 35px;
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		::v-deep {
			.el-input__inner {
				height: 35px;
				border-radius: 0px;
			}
			.el-input__icon {
				display: flex;
				align-items: center;
			}
		}
	}
	.row-item {
		span {
			color: #257ac3;
			margin-right: 5px;
		}
		&:first-child {
			justify-content: flex-start !important;
			padding-left: 20px !important;
		}
	}

	.active {
		text-decoration: underline;
		text-decoration-color: #409eff;
		text-decoration-thickness: 2px;
		text-underline-offset: 6px;
	}
	.tab-item:hover,
	.date-item:hover {
		text-decoration: underline;
		text-decoration-color: #409eff;
		text-decoration-thickness: 2px;
		text-underline-offset: 6px;
	}

	.download-link {
		color: #257ac3;
		text-decoration: underline;
	}
</style>
